module.exports = __webpack_public_path__ + "img/48_24.6f38b646.png";